import { Input } from 'antd'
interface StandardInputProps {
  storedValue: any
  storeValue: Function
  userCanEdit: boolean
}

function StandardInput(props: StandardInputProps) {
  return (
    <Input
      style={{ width: 100 }}
      value={props.storedValue}
      onPressEnter={e => {
        props.storeValue(e.target.value)
      }}
      onBlur={e => {
        props.storeValue(e.target.value)
      }}
      disabled={!props.userCanEdit}
    />
  )
}

export default StandardInput
